import { searchParamValue } from './searchParamValue';
import { afterPathnameKey } from './afterPathnameKey';
import { referrerHostname } from './referrerHostname';

export const selectors = {
  searchParamValue,
  afterPathnameKey,
  referrerHostname,
};
